// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FG7co0yW{word-wrap:break-word;transition:.1s linear;transition-property:transform}@media(hover:hover){.FG7co0yW:hover{transform:scale(1.01)}}@media(hover:none){.FG7co0yW:active{transform:scale(1.01)}}.FG7co0yW:active{transform:scale(.99)}.FG7co0yW>*+*{margin-top:1rem}._7ehi0RKU{aspect-ratio:1.6;border-radius:var(--border-radius);min-height:12.5rem;overflow:hidden;position:relative;width:100%}._5-CexKcu{background-color:var(--color-gray-1);border-radius:inherit;height:100%;left:0;-o-object-fit:cover;object-fit:cover;position:absolute;top:0;width:100%}.qa675T33{padding:.5rem;position:relative}._1tZoBrz3>*+*{margin-top:.5rem}.Yjt2eTLQ{display:-webkit-box;font-size:1.13rem;font-weight:500;line-height:1.1;-webkit-box-orient:vertical;-webkit-line-clamp:5}.F315LtRK,.Yjt2eTLQ{overflow:hidden;text-overflow:ellipsis}.F315LtRK{color:var(--color-gray-4);font-size:.88rem;line-height:1.25;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "FG7co0yW",
	"coverWrapper": "_7ehi0RKU",
	"cover": "_5-CexKcu",
	"tags": "qa675T33",
	"footer": "_1tZoBrz3",
	"title": "Yjt2eTLQ",
	"date": "F315LtRK"
};
module.exports = ___CSS_LOADER_EXPORT___;
